import Input from '../../../Input/Input';
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import './OptionsList.scss';
import Text from '../../../Text/Text';

const OptionsList = forwardRef(
  (
    {
      inputId,
      options,
      isDropdownOpen,
      toggleDropdown,
      onChange,
      dropdownTabIndex,
      rightAligned,
      dropdownSave,
      additionalCssClass,
      filteredDropdown,
      leftAlignedDropdownLabels,
      dropUpwards,
    }: {
      inputId: string;
      options: { value: string; label: string; disabled: boolean }[];
      isDropdownOpen: boolean;
      toggleDropdown: () => void;
      onChange?: (v: unknown) => void;
      dropdownTabIndex?: number;
      rightAligned: boolean;
      dropdownSave?: boolean;
      additionalCssClass?: string;
      filteredDropdown?: boolean;
      leftAlignedDropdownLabels?: boolean;
      dropUpwards?: boolean;
    },
    ref,
  ) => {
    const [searchTerm, setSearchTerm] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
      if (isDropdownOpen && inputRef.current) {
        setTimeout(() => {
          // @ts-expect-error refs
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          inputRef.current.focus();
        }, 100);
      }
    }, [isDropdownOpen]);

    const filteredOptions = useMemo(() => {
      if (!filteredDropdown) return options;

      return options?.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }, [options, searchTerm, filteredDropdown]);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(e.target.value);
    };

    return (
      <ul
        className={`select-dropdown${isDropdownOpen ? ' active' : ''}${rightAligned ? ' right-aligned' : ''}${dropdownSave ? ' dropdown-save' : ''}${dropUpwards ? ' upwards' : ''} ${additionalCssClass}`}
        role="listbox"
        id={`${inputId}-select-dropdown`}
        tabIndex={dropdownTabIndex}
        // @ts-expect-error refs
        ref={ref}
      >
        {filteredDropdown ? (
          <>
            <div className="input-container-spacing">
              <Input
                inputId="option-search"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearch}
                // @ts-expect-error refs
                ref={inputRef}
              />
            </div>
            {filteredOptions?.map((option, i) => {
              return (
                <li
                  className={`list-option${option?.disabled ? ' disabled' : ''}`}
                  data-testid={`${inputId}-option-${option.label}`}
                  role="option"
                  key={i}
                  onClick={() => {
                    if (option?.disabled) return;
                    if (onChange) onChange(option);
                    toggleDropdown();
                  }}
                >
                  <input type="radio" id={option.value} name={option.value} />
                  <label className={`${leftAlignedDropdownLabels && 'left-aligned'} body`}>
                    <Text type="body">{option.label}</Text>
                  </label>
                </li>
              );
            })}
          </>
        ) : (
          <>
            {options?.map((option, i) => {
              return (
                <li
                  className={`list-option${option?.disabled ? ' disabled' : ''}`}
                  data-testid={`${inputId}-option-${option.label}`}
                  role="option"
                  key={i}
                  onClick={() => {
                    if (option?.disabled) return;
                    if (onChange) onChange(option);
                    toggleDropdown();
                  }}
                >
                  <input type="radio" id={option.value} name={option.value} />
                  <label className={`${leftAlignedDropdownLabels && 'left-aligned'} body`}>
                    <Text type="body">{option.label}</Text>
                  </label>
                </li>
              );
            })}
          </>
        )}
      </ul>
    );
  },
);

OptionsList.displayName = 'OptionsList';

export default OptionsList;
